import { connect } from 'react-redux';
import * as statuses from 'services/store/states';
import Navigation from './Navigation';
var mapStateToProps = function (state) { return ({
    hide: state.campaign.status === statuses.FAIL,
    isConfigurationAvailable: state.campaign.type !== 'sales',
    profile: {
        name: state.campaign.name,
    },
    projectId: state.project.id,
}); };
export default connect(mapStateToProps)(Navigation);
